import React from 'react'
import {
  Icon,
  Popup
} from 'semantic-ui-react'

const Mastery = (props) => {
  let icon = <span></span>;
  let tooltip = <span></span>;
  switch (props.mastery) {
    case 'Familiarity':
      icon = <Icon disabled name='quote right'/>;
      tooltip = <p><b>Familiarity</b>: The student understands what a concept is or what it means.</p>;
      break;
    case 'Usage':
      icon = <Icon disabled name='cogs'/>;
      tooltip = <p><b>Usage</b>: The student is able to use or apply a concept in a concrete way.</p>;
      break;
    case 'Assessment':
      icon = <Icon disabled name='balance scale'/>;
      tooltip = <p><b>Assessment</b>: The student is able to consider a concept from multiple viewpoints and/or justify the selection of a particular approach to solve a problem.</p>;
      break;
    default:
  }
  return (
    <Popup trigger={icon} content={tooltip}/>
  );
}

export default Mastery